@include component-spacing-and-grid;

:host {
    display: block;

    h2 {
        @include typo-ws-h2;

        margin: 0;
    }

    p {
        @include typo-ws-paragraph;

        margin: 24px 0 0;
    }

    .items-wrapper:not(.no-intro) {
        border-top: 5px solid currentColor;
        margin-top: 32px;
    }
}

:host(.inside-tab) {
    ::slotted(sew-ws-events-item:last-of-type) {
        border-bottom: 0;
    }
}

@include mq-1 {
    :host {
        p {
            margin-top: 32px;
        }

        .items-wrapper:not(.no-intro) {
            margin-top: 40px;
        }
    }
}

::slotted(sew-ws-button) {
    margin-top: 40px;
}
